import { creatorbase, music } from '@round/api';
import { getTableMetaHelper } from '@round/ui-kit';
import { CellContext } from '@tanstack/react-table';

export type SongsTableRow = creatorbase.Song & {
    musicSong: music.Song | undefined;
    timeSeries: creatorbase.TimeSeriesResponse<'tiktok_daily_change' | 'instagram_daily_change'>[number] | null;
};

export type Meta = {
    isLoading?: boolean;
    hasError?: boolean;
    onEditSong: (song: SongsTableRow) => void;
    onDeleteSong: (song: SongsTableRow) => void;
    isMusicSongLoading: (songId: number) => boolean;
    isTimeSeriesLoading: (songId: number) => boolean;
    isTimeSeriesError: (songId: number) => boolean;
};

export type TableCellContext<TKey extends keyof SongsTableRow> = CellContext<SongsTableRow, SongsTableRow[TKey]>;

export const getTableMeta = getTableMetaHelper<Meta>();
